import {
    getISOWeek, getYear, getMonth,
} from 'date-fns';
import { getColor } from '../colorGenerator';

const getLineGraphDataSet = (data, label, index, hidden, deafultSet) => ({
    id: index,
    label,
    fill: true,
    lineTension: 0,
    backgroundColor: getColor(index, 0.02, deafultSet),
    borderColor: getColor(index, 1, deafultSet),
    borderCapStyle: 'round',
    pointBackgroundColor: getColor(index, 1, deafultSet),
    pointRadius: 6,
    hidden,
    data,
});

const mapDateString = (dateString, groupBy, translation) => {
    const date = new Date(dateString);
    date.setHours(12);

    const year = getYear(date);
    const week = getISOWeek(date);
    const month = getMonth(date);

    switch (groupBy) {
    case 'WEEK': {
        return `${year} v.${week}`;
    }
    case 'MONTH': {
        return `${translation.MONTHS_SHORT[month]} ${year}`;
    }
    default:
        return dateString;
    }
};

const mapStatsToLineChart = (statistics, allDates, groupBy, translation) => {
    const TOTAL_KEY = 'total';

    const labels = allDates.map(dateString => mapDateString(dateString, groupBy, translation));
    const datasets = [];

    Object.keys(statistics).forEach((key, index) => {
        const counts = statistics[key];

        if (key.toLowerCase() === TOTAL_KEY) {
            datasets.push(getLineGraphDataSet(
                counts, key, index, false, true,
            ));
        } else {
            datasets.push(getLineGraphDataSet(
                counts, key, index, true,
            ));
        }
    });

    return {
        labels,
        datasets,
    };
};

export default mapStatsToLineChart;
